import $ from 'jquery'

class MyPreferencesController {
  constructor ($state, UserService, VehicleService, ValidationRules, CookiesService, $location, $anchorScroll, $scope, $rootScope) {
    'ngInject'
    this.$state = $state
    this.userService = UserService
    this.vehicleService = VehicleService
    this.validationRules = ValidationRules
    this.$location = $location
    this.$anchorScroll = $anchorScroll
    this.$scope = $scope
    this.$rootScope = $rootScope
    this.cookiesService = CookiesService

    // Init. default values
    this.isProcessing = true
    this.cards = []

    // Async loading...
    this.loaded = this.init()
  }

  init () {
    return this.userService.getCurrentUser()
    .then((user) => {
      this.user = user
      this.optInATCProfile = user.optInATCProfile
      // Load user wallet...
      return this.userService.getWallet()
    })
    .then((resp) => {
      this.cards = resp.cards
      this.pspType = resp.pspType
      this.isProcessing = false
      this.error = null
      this.safeApply()
      return this.cards
    }, (err) => {
      this.isProcessing = false
      this.safeApply()
      return err
    })
  }

  removeCard (card) {
    this.isProcessing = true
    this.success = null
    this.error = null
    return this.userService.removeCardFromWallet(card.id, this.pspType)
      .then((resp) => {
        this.cards = resp.cards
        this.isProcessing = false
        this.success = 'my-profile.my-credit-cards.delete.success'
        this.error = null
        this.$location.hash('appMessage')
        this.$anchorScroll()
        $('[id="appMessage"]').focus()
        this.safeApply()
      }, (err) => {
        this.isProcessing = false
        this.error = {
          message: 'my-profile.my-credit-cards.delete.error',
          cause: err
        }
        this.$location.hash('appMessage')
        this.$anchorScroll()
        $('[id="appMessage"]').focus()
        this.safeApply()
      })
  }

  submitOptins () {
    this.isProcessing = true
    const optins = {optInATCProfile: this.optInATCProfile}
    return this.userService.update(Object.assign({}, this.user, optins))
      .then((user) => {
        this.isProcessing = false
        this.user = user
        this.optInATCProfile = user.optInATCProfile
        this.success = 'my-profile.my-alerts.success'
        this.error = null
        this.$location.hash('appMessage')
        this.$anchorScroll()
        $('[id="appMessage"]').focus()
        this.safeApply()
      }, (err) => {
        this.isProcessing = false
        this.error = {
          message: 'profile.my-alerts.error',
          cause: err
        }
        this.$location.hash('appMessage')
        this.$anchorScroll()
        $('[id="appMessage"]').focus()
        this.safeApply()
      })
  }

  safeApply () {
    const phase = this.$rootScope.$$phase
    if (phase !== '$apply' && phase !== '$digest') {
      this.$scope.$apply()
    }
  }

  openCookiesBanner () {
    this.cookiesService.requestEdit = true
  }
}

export default MyPreferencesController



// WEBPACK FOOTER //
// ./src/app/pages/profile/my-profile/my-preferences/my-preferences.controller.js